__turbopack_context__.v({
  "shopCardBody": "ShopProductCardPrimitives-module__4oBR5a__shopCardBody",
  "shopCardBottomSheet": "ShopProductCardPrimitives-module__4oBR5a__shopCardBottomSheet",
  "shopCardFlipImg": "ShopProductCardPrimitives-module__4oBR5a__shopCardFlipImg",
  "shopCardFooterRow": "ShopProductCardPrimitives-module__4oBR5a__shopCardFooterRow",
  "shopCardMedia": "ShopProductCardPrimitives-module__4oBR5a__shopCardMedia",
  "shopCardMediaDimBackdrop": "ShopProductCardPrimitives-module__4oBR5a__shopCardMediaDimBackdrop",
  "shopCardPriceCluster": "ShopProductCardPrimitives-module__4oBR5a__shopCardPriceCluster",
  "shopCardPrimaryCta": "ShopProductCardPrimitives-module__4oBR5a__shopCardPrimaryCta",
  "shopCardSpecSection": "ShopProductCardPrimitives-module__4oBR5a__shopCardSpecSection",
  "shopCardTag": "ShopProductCardPrimitives-module__4oBR5a__shopCardTag",
  "shopProductCardRoot": "ShopProductCardPrimitives-module__4oBR5a__shopProductCardRoot",
});
